import React from 'react';
import { Box, Typography } from '@mui/material';

type PointStateCardProps = {
  title: string;
  imageUrl: string;
  value?: number;
  color: string;
  onClick?: () => void;
};

export function PointStateCard(props: PointStateCardProps) {
  const handleClick = () => {
    if (props.onClick && typeof props.value === 'number') {
      props.onClick();
    }
  };
  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'start',
        gap: 3,
        flex: 1,
        minWidth: 100,
        cursor: 'pointer',
      }}
      onClick={handleClick}
    >
      <Typography variant="h6">{props.title}</Typography>
      <Box style={{ display: 'flex', width: 45, height: 45 }}>
        <img src={props.imageUrl} alt="Point State" style={{ width: '100%' }} />
      </Box>
      <Typography style={{ color: props.color }}>
        {typeof props.value === 'number' ? props.value.toFixed(2) : '-'}
      </Typography>
    </Box>
  );
}
